import i18n from "./i18n";
import { store } from "./../vuex/store";

export default {
	install(Vue, options) {
		Vue.prototype.$appOptions = {
			publicPath: function () {
				return process.env.MIX_APP_URL;
			},
			tenantLogo: function () {
				return store.getters.getCompanyLogo;
			},
			systemLogo: function () {
				return process.env.MIX_APP_URL + "/img/logo_system_rettangolo.svg";
			},
			systemLogoQuadrato: function () {
				return process.env.MIX_APP_URL + "/img/logo_system_quadrato.svg";
			},
			canAutofocus: function () {
				if (store.getters.isTouch) {
					return false;
				}
				return true;
			},
			systemMessagesType: function (value = null) {
				let types = [
					{ value: "update", label: i18n.t("systemmessages.update") },
					{ value: "warning", label: i18n.t("systemmessages.warning") },
				];
				if (value != null) {
					return types.find((obj) => obj.value == value).label;
				}
				return types;
			},
			genders: function (value = null) {
				let types = [
					{ value: null, label: i18n.t("associates.gender_other") },
					{ value: "M", label: i18n.t("associates.gender_male") },
					{ value: "F", label: i18n.t("associates.gender_female") },
				];
				if (value != null) {
					return types.find((obj) => obj.value == value).label;
				}
				return types;
			},
			autocompleteAdminClients: function (value = null) {
				let types = store.getters.getAutocompleteAdminClients;
				if (!types) {
					if (!store.getters.autocompleteadminclients_loading) {
						store.dispatch("fetchAutocompleteAdminClients");
					}
					if (value != null) {
						return {};
					}
					return [];
				} else {
					if (value != null) {
						let finded = types.find((obj) => obj.id == value);
						if (finded) {
							return finded;
						}
						return {};
					}
					return types;
				}
			},
			attachmentCategories: function (value = "all") {
				let types = [
					{ value: null, label: i18n.t("attachment.category.other") },
					{ value: "certificate", label: i18n.t("attachment.category.certificate") },
					{ value: "privacy", label: i18n.t("attachment.category.privacy") },
				];
				if (value != "all") {
					return types.find((obj) => obj.value == value).label;
				}
				return types;
			},
			dialogsWidthPercentage: function () {
				return 55;
			},
			dialogsWidth: function () {
				return "800";
			},
			largeDialogsWidthPercentage: function () {
				return 80;
			},
			largeDialogsWidth: function () {
				return "1000";
			},
			smallDialogsWidth: function () {
				return "400";
			},
			debounceTime: function () {
				return 400;
			},
			defaultRowsPerPage: function () {
				let settings = store.getters.getUserConfig.settings;
				return settings.DefaultRowsInTable;
			},
			days: function () {
				return [
					{ name: i18n.t("global.days.d1"), day: 1 },
					{ name: i18n.t("global.days.d2"), day: 2 },
					{ name: i18n.t("global.days.d3"), day: 3 },
					{ name: i18n.t("global.days.d4"), day: 4 },
					{ name: i18n.t("global.days.d5"), day: 5 },
					{ name: i18n.t("global.days.d6"), day: 6 },
					{ name: i18n.t("global.days.d7"), day: 7 },
				];
			},
			calendar: function () {
				let tenantConfig = store.getters.getTenantConfig;
				let options = {
					intervalHeight: 40,
					displayedHours: 17,
					day_start: 7,
					weekdays: [1, 2, 3, 4, 5, 6, 0],
				};
				if (tenantConfig.settings) {
					options.day_start = tenantConfig.settings.AgendaMinTime;
					if (tenantConfig.settings.AgendaMaxnTime) {
						options.displayedHours = moment(tenantConfig.settings.AgendaMaxnTime, "HH:mm").diff(moment(options.day_start, "HH:mm"), "hours", true);
					} else {
						options.displayedHours = moment("23:00", "HH:mm").diff(moment(options.day_start, "HH:mm"), "hours", true);
					}
					if (!tenantConfig.settings.AgendaShowWeekend) {
						options.weekdays = [1, 2, 3, 4, 5];
					}
				}
				return options;
			},
			colorsPalette: function () {
				return [
					["#FBD966", "#E06666"],
					["#F6B26B", "#93C47D"],
					["#76A5AF", "#6D9EEB"],
					["#8E7CC3", "#C27BA0"],
				];
			},
			getYearData: function (year = "current", type = "start") {
				if (year == "current") {
					if (type == "start") {
						return moment().startOf("year").format("YYYY-MM-DD");
					} else {
						return moment().endOf("year").format("YYYY-MM-DD");
					}
				} else {
					if (type == "start") {
						return moment().subtract(1, "year").startOf("year").format("YYYY-MM-DD");
					} else {
						return moment().subtract(1, "year").endOf("year").format("YYYY-MM-DD");
					}
				}
			},
			years: function (value = null) {
				let max = moment().format("YYYY");
				let years = [];
				let min = moment().add(-3, "years").format("YYYY");
				for (let year = min; year <= max; year++) {
					years.push(parseInt(year).toString());
				}
				return years;
			},
			dateFilter: function (value = null) {
				let types = [
					{ value: "7days", label: "Ultimi 7 giorni", date_start: moment().subtract(7, "days").format("YYYY-MM-DD"), date_end: moment().format("YYYY-MM-DD") },
					{ value: "currentmonth", label: "Mese corrente", date_start: moment().startOf("month").format("YYYY-MM-DD"), date_end: moment().endOf("month").format("YYYY-MM-DD") },
					{ value: "previousmonth", label: "Mese precedente", date_start: moment().subtract(1, "month").startOf("month").format("YYYY-MM-DD"), date_end: moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD") },
					{ value: "30days", label: "Ultimi 30 giorni", date_start: moment().subtract(30, "days").format("YYYY-MM-DD"), date_end: moment().format("YYYY-MM-DD") },
					{ value: "currentyear", label: "Anno corrente", date_start: this.getYearData("current", "start"), date_end: this.getYearData("current", "end") },
					{ value: "previousyear", label: "Anno precedente", date_start: this.getYearData("previous", "start"), date_end: this.getYearData("previous", "end") },
					{ value: "fromever", label: "Da sempre", date_start: "2010-01-01", date_end: moment().endOf("year").format("YYYY-MM-DD") },
					{ value: "custom", label: "Personalizzato" },
				];
				if (value != null) {
					return types.find((obj) => obj.value == value);
				}
				return types;
			},
			ageFilter: function (value = null) {
				let types = [
					{ value: "all", label: "Tutti", age_min: null, age_max: null },
					{ value: "minor", label: "0-18", age_min: 0, age_max: 18 },
					{ value: "adult", label: "18+", age_min: 18, age_max: 100 },
					{ value: "custom", label: "Personalizzato" },
				];
				if (value != null) {
					return types.find((obj) => obj.value == value);
				}
				return types;
			},
			calendarTypes: function () {
				let options = [
					{ text: i18n.t("calendar.day"), value: "day" },
					{ text: i18n.t("calendar.fourday"), value: "4day" },
					{ text: i18n.t("calendar.week"), value: "week" },
					{ text: i18n.t("calendar.month"), value: "month" },
				];
				return options;
			},
			festivities: function () {
				return [
					{ date: "2019-01-01", label: i18n.t("festivity.capodanno") },
					{ date: "2019-01-06", label: i18n.t("festivity.epifania") },
					{ date: "2019-04-21", label: i18n.t("festivity.pasqua") },
					{ date: "2019-04-22", label: i18n.t("festivity.pasquetta") },
					{ date: "2019-04-25", label: i18n.t("festivity.liberazione") },
					{ date: "2019-05-01", label: i18n.t("festivity.festalavoro") },
					{ date: "2019-06-02", label: i18n.t("festivity.festarepubblica") },
					{ date: "2019-08-15", label: i18n.t("festivity.ferragosto") },
					{ date: "2019-11-01", label: i18n.t("festivity.santi") },
					{ date: "2019-12-08", label: i18n.t("festivity.immacolata") },
					{ date: "2019-12-25", label: i18n.t("festivity.natale") },
					{ date: "2019-12-26", label: i18n.t("festivity.santostefano") },
					{ date: "2020-01-01", label: i18n.t("festivity.capodanno") },
					{ date: "2020-01-06", label: i18n.t("festivity.epifania") },
					{ date: "2020-04-12", label: i18n.t("festivity.pasqua") },
					{ date: "2020-04-13", label: i18n.t("festivity.pasquetta") },
					{ date: "2020-04-25", label: i18n.t("festivity.liberazione") },
					{ date: "2020-05-01", label: i18n.t("festivity.festalavoro") },
					{ date: "2020-06-02", label: i18n.t("festivity.festarepubblica") },
					{ date: "2020-08-15", label: i18n.t("festivity.ferragosto") },
					{ date: "2020-11-01", label: i18n.t("festivity.santi") },
					{ date: "2020-12-08", label: i18n.t("festivity.immacolata") },
					{ date: "2020-12-25", label: i18n.t("festivity.natale") },
					{ date: "2020-12-26", label: i18n.t("festivity.santostefano") },
					{ date: "2021-01-01", label: i18n.t("festivity.capodanno") },
					{ date: "2021-01-06", label: i18n.t("festivity.epifania") },
					{ date: "2021-04-04", label: i18n.t("festivity.pasqua") },
					{ date: "2021-04-05", label: i18n.t("festivity.pasquetta") },
					{ date: "2021-04-25", label: i18n.t("festivity.liberazione") },
					{ date: "2021-05-01", label: i18n.t("festivity.festalavoro") },
					{ date: "2021-06-02", label: i18n.t("festivity.festarepubblica") },
					{ date: "2021-08-15", label: i18n.t("festivity.ferragosto") },
					{ date: "2021-11-01", label: i18n.t("festivity.santi") },
					{ date: "2021-12-08", label: i18n.t("festivity.immacolata") },
					{ date: "2021-12-25", label: i18n.t("festivity.natale") },
					{ date: "2021-12-26", label: i18n.t("festivity.santostefano") },
					{ date: "2022-01-01", label: i18n.t("festivity.capodanno") },
					{ date: "2022-01-06", label: i18n.t("festivity.epifania") },
					{ date: "2022-04-17", label: i18n.t("festivity.pasqua") },
					{ date: "2022-04-18", label: i18n.t("festivity.pasquetta") },
					{ date: "2022-04-25", label: i18n.t("festivity.liberazione") },
					{ date: "2022-05-01", label: i18n.t("festivity.festalavoro") },
					{ date: "2022-06-02", label: i18n.t("festivity.festarepubblica") },
					{ date: "2022-08-15", label: i18n.t("festivity.ferragosto") },
					{ date: "2022-11-01", label: i18n.t("festivity.santi") },
					{ date: "2022-12-08", label: i18n.t("festivity.immacolata") },
					{ date: "2022-12-25", label: i18n.t("festivity.natale") },
					{ date: "2022-12-26", label: i18n.t("festivity.santostefano") },
					{ date: "2023-01-01", label: i18n.t("festivity.capodanno") },
					{ date: "2023-01-06", label: i18n.t("festivity.epifania") },
					{ date: "2023-04-09", label: i18n.t("festivity.pasqua") },
					{ date: "2023-04-10", label: i18n.t("festivity.pasquetta") },
					{ date: "2023-04-25", label: i18n.t("festivity.liberazione") },
					{ date: "2023-05-01", label: i18n.t("festivity.festalavoro") },
					{ date: "2023-06-02", label: i18n.t("festivity.festarepubblica") },
					{ date: "2023-08-15", label: i18n.t("festivity.ferragosto") },
					{ date: "2023-11-01", label: i18n.t("festivity.santi") },
					{ date: "2023-12-08", label: i18n.t("festivity.immacolata") },
					{ date: "2023-12-25", label: i18n.t("festivity.natale") },
					{ date: "2023-12-26", label: i18n.t("festivity.santostefano") },
					{ date: "2024-01-01", label: i18n.t("festivity.capodanno") },
					{ date: "2024-01-06", label: i18n.t("festivity.epifania") },
					{ date: "2024-03-31", label: i18n.t("festivity.pasqua") },
					{ date: "2024-04-01", label: i18n.t("festivity.pasquetta") },
					{ date: "2024-04-25", label: i18n.t("festivity.liberazione") },
					{ date: "2024-05-01", label: i18n.t("festivity.festalavoro") },
					{ date: "2024-06-02", label: i18n.t("festivity.festarepubblica") },
					{ date: "2024-08-15", label: i18n.t("festivity.ferragosto") },
					{ date: "2024-11-01", label: i18n.t("festivity.santi") },
					{ date: "2024-12-08", label: i18n.t("festivity.immacolata") },
					{ date: "2024-12-25", label: i18n.t("festivity.natale") },
					{ date: "2024-12-26", label: i18n.t("festivity.santostefano") },
				];
			},
		};
	},
};
